import _taggedTemplateLiteral from "@babel/runtime-corejs2/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media only screen and (min-width: ", ") {\n      ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { BREAK_POINTS } from '../consts/mediaQuery.const';
var styledCss = css;
export var media = {
  SM: function SM() {
    return styledCss(_templateObject(), BREAK_POINTS.Min.SM, styledCss.apply(void 0, arguments));
  },
  MD: function MD() {
    return css(["@media only screen and (min-width:", "){", ";}"], BREAK_POINTS.Min.MD, styledCss.apply(void 0, arguments));
  },

  /* Large devices (desktops, 992px and up) */
  LG: function LG() {
    return css(["@media only screen and (min-width:", "){", ";}"], BREAK_POINTS.Min.LG, styledCss.apply(void 0, arguments));
  },

  /* Extra large devices (large desktops, 1200px and up) */
  XL: function XL() {
    return css(["@media only screen and (min-width:", "){", ";}"], BREAK_POINTS.Min.XL, styledCss.apply(void 0, arguments));
  }
};